<template lang="pug">
b-container#page.home
  b-row
    .col-4
      //h1 {{ msg }}
      h2 Nueva reserva/venta
      b-form(inline v-if="user")
        b-form-group#input-counter-group(label='Counter:' description="¡Buenos días!")
          b-form-input#input-counter.mr-sm-2(v-model="user.firstName + ' ' + user.lastName" size='sm' placeholder='Usuario' disabled)
          b-button.my-2.my-sm-0(size='sm' type='submit') Salir
      px-form(:airports="airports")
    .col-8
      px-cards(title="Operaciones")
</template>

<script>
// @ is an alias to /src
import PxCard from "@/components/PxCard.vue";
import PxCards from "@/components/PxCards.vue";
import PxForm from "@/components/PxForm.vue";

import { mapState, mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    "px-card": PxCard,
    "px-cards": PxCards,
    "px-form": PxForm,
  },
  computed: {
    ...mapState(["user", "airports"]),
    ...mapGetters(["user", "airports"]),
    /*passengerCount() {
      let passengerArray = Array(parseInt(this.form.passengerNumber));
      passengerArray.fill("");
      return passengerArray;
    },*/
  },
  mounted() {
    //this.$store.dispatch("loadItems");
  },
};
</script>
